import { InvoiceType } from '@carvia/ros-client-types';

export function receivablesBooleanQueryParam(filter: string | null): boolean | undefined {
  if (filter === 'true') return true;
  if (filter === 'false') return false;
  return undefined;
}

export function receivablesInvoiceTypesParam(
  invoicedFilter: string | null,
  selectedInvoiceTypes: string[],
): string[] | undefined {
  const types = selectedInvoiceTypes.filter((value) => value.toUpperCase() !== 'NULL');
  if (invoicedFilter === 'uninvoiced') return ['NULL'];
  if (invoicedFilter === 'invoiced') {
    return types.length ? types : Object.values(InvoiceType);
  }
  return types.length ? types : undefined;
}
